<template>
  <div id="combo_payOldOrder">
    <mt-header title="订单付费">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
    </mt-header>
    <div id="combo_payOldOrder_content">
      <div class="comboDetail">
        <div class="comboDetail-show">
          <div class="comboView">订单编号:</div>
          <div class="comboDetail-show-detail">{{ orderNo }}</div>
          <hr class="combohr">
        </div>
        <div class="comboDetail-show">
          <div class="comboView">套餐名称:</div>
          <div class="comboDetail-show-detail">{{ name }}</div>
          <hr class="combohr">
        </div>

        <div class="comboDetail-show">
          <div class="comboView" style="margin-bottom: 1rem;">付费类型:</div>
          <div class="comboDetail-show-detail">{{paidMode | paidModeFormat}}</div>
          <hr class="combohr">
        </div>

        <div v-if="paidMode != '2'" class="comboDetail-show">
          <div class="comboView">购买次数:</div>
          <div class="comboDetail-show-detail">{{ number }}</div>
          <hr class="combohr">
        </div>

        <div v-if="paidMode != 1" class="comboDetail-show">
          <div class="comboView">有效天数:</div>
          <div class="comboDetail-show-detail">{{ days }}</div>
          <hr class="combohr">
        </div>

        <div class="comboDetail-show">
          <div class="comboView-price">价格:</div>
          <div class="comboDetail-show-detail" style="color: red">￥{{price}}</div>
          <hr class="combohr">
        </div>
      </div>


      <div class="comboDetail-show-detail-pay">
        <div align="left" style="font-size:16px;color:#7d7d7d">
          支付方式
          <span style="font-size: 12px; color: #1f74d8; line-height: 24px; margin-left: 10px;">注：充值次数用于平台服务，不可退款。</span>
        </div>
        <!--<mt-button class="login-btn" size="large" type="primary" @click="buyCombo()">付款</mt-button>-->
        <div style="float:left;width:50%;text-align: center;">
            <img class="payImg"  style="margin-top: 20px;" @click="wxpay()" src="/static/img/combo/wxpay.png">
            <div>微信支付</div>
        </div>
        <div style="float:left;width:50%;text-align: center;">
            <img class="payImg" style="margin-top: 20px" @click="alipay()" src="/static/img/combo/alipay.png">
            <div>支付宝支付</div>
        </div>
        <!-- <div style="clear:both; text-align: center; font-size: 12px; color: #1f74d8; line-height: 24px; font-weight: 500;">
          <span>我理解并认可，充值次数用于平台服务，不可退款。</span>
        </div> -->
      </div>
    </div>
    <div id="payId">
    </div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import cheader from '@/components/header';

  export default {
    data() {
      return {
        id: -1,
        orderNo: '',
        paidMode: '',
        price: 0.0,
        number: 0,
        days: 0,
        name: "",
        content: "",
        list: [{value: 'alipay', isCheck: true, name: '支付宝'}, {value: 'weixinpay', isCheck: false, name: '微信'}]
      }
    },
    methods: {
      alipay: function () {
        var payOldOrderURL = domain("_payOldOrder");
        var that = this;
        that.$http.post(
          payOldOrderURL, {
            orderId: this.id
          },
          {emulateJSON: true}
        )
          .then(function (response) {  //接口返回数据
            var result = response.bodyText;
            if (result == 'orderIsSuccess') {
              Toast("支付成功.");
              this.$router.push({
                path: "/combo/comboRecord",
                name: 'comboRecord'
              })
            } else {
              document.getElementById("payId").innerHTML = result;
              document.forms[0].submit();
            }

          }, function (error) {
            console.log(error);
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          console.log(response);
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      wxpay: function () {
          var wxpayURL = domain("_wxpayOldOrder");
          var that = this;
          that.$http.post(
            wxpayURL, {
              orderNo: this.orderNo
            },
            {emulateJSON: true}
          )
            .then(function (response) {  //接口返回数据
              var code = response.data.code;

              if (code == '0') {
                var mweb_url = response.data.data.mweb_url;
                window.location.href = mweb_url;
              } else {
                this.goBack();
              }

            }, function (error) {
              console.log(error);
              //Toast("数据获取响应异常.")
            }).catch(function (response) {
            console.log(response);
            //Toast("数据获取响应异常.");
          })
      },
      buyCombo: function () {
        var selectedValue;
        this.list.map(function (v) {
          if (v.isCheck) {
            selectedValue = v.value;
          }
        });
        if ('alipay' == selectedValue) {
          this.alipay();
        } else {
          this.wxpay();
        }

      },
      changeInput(index) {
        this.list.map(function (v, i) {
          if (i == index) {
            v.isCheck = true
          } else {
            v.isCheck = false
          }
        });
      },
      goBack: function () {
        history.go(-1); //后退1页
      },
      initParams() {
        this.orderNo = this.$route.query.orderNo;
        this.id = this.$route.query.id;
        this.fetcchMsg();
      },
      fetcchMsg() {
        var getOrderByOrderNoURL = domain("_getOrderByOrderNo");
        var that = this;
        that.$http.post(
          getOrderByOrderNoURL, {
            orderNo: this.orderNo
          },
          {emulateJSON: true}
        )
          .then(function (response) {  //接口返回数据
            this.content = response.data.data.content;
            this.paidMode = response.data.data.paidMode;
            this.price = response.data.data.price;
            this.number = response.data.data.number;
            this.days = response.data.data.days;
            this.name = response.data.data.comboName;
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      }
    },
    filters: {
      paidModeFormat(paidMode) {
        if (paidMode == '1') {
          return '次数';
        } else if (paidMode == '2') {
          return '天数';
        } else if (paidMode == '3') {
          return '次数与天数';
        }
      }
    },
    components: {},
    mounted: function () {
      this.initParams();
    }

  }
</script>
<style>

  .combohr {
    width: 100%;
    height: 0;
    border: 1px dashed #d4d4d4;
    margin-top: 1.5rem;

  }

  .payImg {
    width: 38px;
    height: 38px;
  }

  #combo_payOldOrder_content {
    height: 100%;
    font-size: 0.8rem;
    font-family: "Microsoft YaHei";
  }

  .comboDetail {
    /* margin-left: 4%;
    margin-right: 4%; */
    width:90%;
    margin:0 auto;
    background-color: #ffffff;
    font-size: 16px;
    /*color: #7d7d7d;*/
    font-family: "Microsoft YaHei";
    border-radius: 5px;
    margin-top: 0.4rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .comboView {
    width: 25%;
    float: left;
    text-align: left;
    display: block;
    color: #7d7d7d;
  }

  .comboView-price {
    float: left;
    text-align: left;
    display: block;
    color: #7d7d7d;
  }

  .comboDetail-show {
    padding-top: 0.8rem;
    margin-bottom: 0.5rem;
  }

  .comboDetail-show-detail {
    margin-left: 25%;
    width: 75%;
    text-align: right;
  }

  .comboDetail-show-detail-price {
    margin-left: 0.5rem;
    color: #f09536;
  }

  .comboDetail-show-detail-pay {
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    padding-bottom: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/module/combo/PayOldOrder.vue